import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

import { StorageService } from "@hermes/app-core";
import {
    GridFacade,
    GridProduct,
    GridType,
    UrlManagerService,
} from "@hermes/states/grid-filters-state";

/**
 * This resolver ensure that grid page is accessed only when products are resolved.
 */
@Injectable()
export class SearchProductsResolver implements Resolve<GridProduct[]> {
    constructor(
        private gridFacade: GridFacade,
        private urlManager: UrlManagerService,
        private storageService: StorageService,
    ) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<GridProduct[]> {
        const gridDataFromUrl = this.urlManager.parseRoute(route);

        this.gridFacade.initGridPage({
            displayMode:
                this.storageService.getSessionStorageItem("gridDisplayMode"),
            gridType: GridType.search,
            searchTerm: route.queryParams.s,
            ...gridDataFromUrl,
            pageNumber: 1,
        });

        return this.gridFacade.products$.pipe(first(Boolean));
    }
}
